// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"main_mainContainer__1ksrQ","contactContainer":"main_contactContainer__gGIcb","widgetContainer":"main_widgetContainer__-gS5C"};